/**
 * Validates if a string is a valid URI string.
 *
 * @param azsolId - The AZSOL identifier string to validate as a valid URI
 * @returns boolean
 */
export const isValidUriString = (azsolId: string) => {
  // Check that the given azsolId or any sring that is passed is URI compatible
  // Should only alphanumeric characters, spaces, underscores, and hyphens
  const validPattern = /^[a-zA-Z0-9 _-]+$/;
  return validPattern.test(azsolId);
};
